// extracted by mini-css-extract-plugin
module.exports = {"header":"HotModal_style_header__2mDL-","main":"HotModal_style_main__10jGr","img":"HotModal_style_img__EXXUb"};